import {
	Breakpoints,
	BreakpointWrapper,
	Layout,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { CustomBreakpoints } from '../../helpers/breakpoints';
import { CarlineWithOfertas } from '../../services/ofertas-service/models/ofertas';
import { OfertaCardsContainer } from '../oferta-card/oferta-cards-container';
import { ModelCarrousel } from './model-carrousel/model-carrousel';

const CardContainer = styled.div`
	position: relative;
	left: 0;
	width: 100vw;

	@media screen and (min-width: 1200px) {
		& > div {
			height: 100%;
			align-content: center;
		}
	}
`;

// const ModelFrameContainer = styled.div`
// 	height: 100vh;
// 	@media screen and (min-width: 1200px) {
// 		position: relative;
// 	}
// `;

export const ModelFrameContent = styled.div<{ hasOneCarline: boolean }>`
	width: 100%;
	height: ${(props) => (props.hasOneCarline ? 'auto' : '100vh')};
	overflow: hidden;

	@media screen and (min-width: 1200px) {
		display: flex;
		align-items: center;
		justify-content: space-evenly;
		position: relative;
	}
`;

export const ModelFrame = ({
	carline,
	hasOneCarline,
}: {
	carline: CarlineWithOfertas;
	hasOneCarline: boolean;
}): React.ReactElement => {
	return (
		<ModelFrameContent
			hasOneCarline={hasOneCarline}
			className={`ofertas__model-frame-${carline.name}`}
		>
			{/* Desktop >960 */}
			<ModelCarrousel />

			{/* Desktop >1200 */}
			<BreakpointWrapper
				min={CustomBreakpoints.DESKTOP}
				data-testid="model-frame__breakpoint-wrapper-desktop"
			>
				<CardContainer className="model-frame__card-container-desktop">
					<Layout
						data-testid="model-frame__layout-ofertas-card-desktop"
						appearance={{
							[Breakpoints.default]: [{ name: 'a', columns: 24 }],
							[Breakpoints.b960]: [
								{ name: '.', columns: 1 },
								{ name: 'a', columns: 22 },
								{ name: '.', columns: 1 },
							],
							[CustomBreakpoints.DESKTOP]: [
								{ name: '.', columns: 14 },
								{ name: 'a', columns: 9 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b1920]: [
								{ name: '.', columns: 15 },
								{ name: 'a', columns: 8 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b2560]: [
								{ name: '.', columns: 16 },
								{ name: 'a', columns: 6 },
								{ name: '.', columns: 1 },
							],
						}}
					>
						<OfertaCardsContainer
							className="model-frame__ofertas-card-container-desktop"
							carline={carline}
							isMobile={false}
						/>
					</Layout>
				</CardContainer>
			</BreakpointWrapper>
		</ModelFrameContent>
	);
};
